import extensionConfigurations from './extension-configurations';
import extensions from './extensions';

export default {
  extensionConfigurations,
  extensions,
};
